import { useEffect, useRef } from 'react';

import { detectWalletNetworkChainIdAsync } from '#/lib/ethereum/wallets/switchEthereumChain';
import { staticDispatch, useSelector } from '#/reduxState/store';
import { changeWalletChainId } from '#/reduxState/wallet/walletDetailsReducer';

function WalletNetworkChainWatcher() {
  const wallet = useSelector(state => state.wallet);
  const walletChainId = useSelector(state => state.walletDetail.walletChainId);
  const changedOnce = useRef(false);

  useEffect(() => {
    // Reset changed after wallet change
    changedOnce.current = false;
  }, [wallet.walletAddress]);

  useEffect(() => {
    if (changedOnce.current) {
      // Allow only one chain chain trigger per session
      // Otherwise we can get into infinite loop in some cases
      return;
    }
    setTimeout(() => {
      // Note: WalletConnect is listening directly in connector (see walletConnect.ts)
      detectWalletNetworkChainIdAsync(wallet)
        .then(chainId => {
          if (chainId && Number(chainId) !== walletChainId) {
            changedOnce.current = true;
            staticDispatch(changeWalletChainId(chainId));
          }
        })
        .catch(error => {
          console.warn(error);
        });
    }, 2000);
  }, [changedOnce, wallet, walletChainId]);

  return null;
}

export default WalletNetworkChainWatcher;
